export default {"src":"/_next/static/media/delete.d5cf399b.svg","height":26,"width":26,"blurWidth":0,"blurHeight":0};